export default __webpack_public_path__ + "static/media/4. UC Personal.ce99fd26.pdf";